import { client } from '@/client';

// 获取组
export function getOrganizeList(params) {
  return client.post('/api/sys_group_service/listGroup', params);
}

// 更新组
export function updateOrganize(params) {
  return client.post('/api/sys_group_service/update', params);
}

// 创建组
export function createOrganize(params) {
  return client.post('/api/sys_group_service/create', params);
}

// 删除组
export function deleteOrganize(id) {
  return client.post(`/api/sys_group_service/delete`, { id });
}

// 管理用户
export function manageUser(params) {
  return client.post('/api/sys_group_service/users', params);
}

// 管理资源
export function manageResource(params) {
  return client.post('/api/sys_group_service/resources', params);
}

// 获取所有集群
export function getClusterList() {
  return client.get('/api/sys_group_service/clusters');
}

// 获取所有角色
export function getRoleList(params) {
  return client.get('/api/sys_group_service/roles', params);
}

// 获取kafka topics
export function getKafkaTopics(params) {
  return client.get('/api/sys_group_service/kafkatopics', params);
}

// 获取所有namespace(pulsar/kop)
export function getNamespace(params) {
  return client.get('/api/sys_group_service/namespaces', params);
}

// 根据groupId 获取详情
export function getGroupDetail(groupId) {
  return client.get('/api/sys_group_service/resource', { groupId });
}

// 获取集群类型
export function getClusterType() {
  return client.get(`/api/sys_group_service/dictionary/getClusterType`);
}
